import React from "react";
import "./FeaturedSection.css";
import featureImg1 from "../../../Images/newsRdImg1.jpg";
import featureImg2 from "../../../Images/newsRdImg2.jpg";
import featureImg3 from "../../../Images/newsRdImg3.jpg";

const FeaturedSection = () => {
  return (
    <div className="featuredContainer">
      <h2 className="featuredTitle">Code Smarter with Real-World Practice</h2>
     <p className="featuredDescription">
  At CareerRestorer, our courses are designed to bridge the gap between learning and industry application. 
  You’ll gain hands-on experience in programming, cloud computing, AI, cybersecurity, and more — 
  preparing you for real-world challenges and future-ready tech careers.
</p>

      <div className="featuredCards">
        <div className="featuredCard">
          <img src={featureImg1} alt="Web Development" />
          <div className="featuredContent">
            <h3>Web Development</h3>
            <p>
              Learn HTML, CSS, JavaScript, and modern frameworks to build
              responsive websites and web applications.
            </p>
          </div>
        </div>

        <div className="featuredCard">
          <img src={featureImg2} alt="Data Science" />
          <div className="featuredContent">
            <h3>Data Science & AI</h3>
            <p>
              Master Python, data analysis, machine learning, and AI with
              hands-on projects.
            </p>
          </div>
        </div>

        <div className="featuredCard">
          <img src={featureImg3} alt="Cybersecurity" />
          <div className="featuredContent">
            <h3>Cybersecurity</h3>
            <p>
              Learn to protect businesses with advanced cybersecurity solutions
              and penetration testing skills.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedSection;
